import actionCreators from './actions';
import reducers from './reducers';

const addEndPoint = (store, reply) => {
    const dict = reply(store);
    return {
        actions: actionCreators(dict.conf, dict.endPoints),
        reducers: reducers(dict.endPoints),
    };
};

// export createReducers = (endPoints) => {
//   return reducers(endpoints)
// }

// export createActions = (conf, endpoints) => {
//   return actionCreators(conf, endPoints)
// }

export default addEndPoint;
